module.exports = __webpack_public_path__ + "mainassets/img/faq-intro-a.1df195fe.svg";